export const CODE_ERRORS = {
  STATUS_RESPONSE_CAT: {
    message: "Por el momento el servicio no está disponible, por favor inténtalo más tarde.",
    code: "GOTA02",
    status: "STATUS_RESPONSE_CAT",
    title: "Ocurrió un error",
    image: "ta-disconnected",
    icon: "plug"
  },
  STATUS_RESPONSE_KE: {
    message: "Por el momento el servicio no está disponible, por favor inténtalo más tarde.",
    code: "GOTA03",
    status: "STATUS_RESPONSE_KE",
    title: "Ocurrió un error",
    image: "ta-disconnected",
    icon: "plug"
  },
  STATUS_RESPONSE_SSO: {
    message: "Por el momento el servicio no está disponible, por favor inténtalo más tarde.",
    code: "GOTA01",
    status: "STATUS_RESPONSE_SSO",
    title: "Ocurrió un error",
    image: "ta-disconnected",
    icon: "plug"
  },
  STATUS_RESPONSE_GEO: {
    message: "Activa tu geolocalización en tu dispositivo para continuar utilizando SuperMóvil.",
    code: "RC_0001",
    status: "STATUS_RESPONSE_GEO",
    title: "¿Nos ayudas con tu ubicación?",
    image: "ta-geolocation",
    icon: "location"
  },
  STATUS_RESPONSE_TYC: {
    message: "Actualiza la versión más reciente desde la tienda de apps de tu dispositivo para continuar utilizando SuperMóvil.",
    code: "RC_0004",
    status: "STATUS_RESPONSE_TYC",
    title: "¡Es momento de actualizar tu app!",
    image: "ta-update_app",
    icon: "mobile"
  },
  STATUS_NO_ACC: {
    message: "Verifica el estatus de tu cuenta.",
    code: "RC_0005",
    status: "STATUS_NO_ACC",
    title: "No es posible continuar",
    image: "ta-without_accounts",
    icon: "card"
  },
  STATUS_RESPONSE_PAY: {
    message: "Por el momento el servicio no está disponible, por favor inténtalo más tarde.",
    code: "GOTA05",
    status: "STATUS_RESPONSE_PAY",
    title: "Ocurrió un error",
    image: "ta-disconnected",
    icon: "plug"
  },
  FORW00: {
    message: 'Su recarga está en proceso. Por favor validar en unos minutos la actualización de su saldo.'
  },
  NO_ACCOUNTS: {
    message: "Por ahora no puedes continuar. Por favor comunícate a SuperLínea para resolver el problema.",
    code: "",
    status: "",
    title: "Algo salió mal",
    image: "",
    icon: "savings"
  },
  STATUS_RESPONSE_NUMBER: {
    message: "Revisa el código de área y tu número celulare inténtalo de nuevo.",
    code: "",
    status: "",
    title: "Verifica el número de teléfono",
    image: "ta-update_app",
    icon: "mobile"
  },
}
